<cap-content-header>
  <cap-title>
    {{ "auftrag.ListTitel" | translate }}
  </cap-title>
  <cap-title-functionbar>
    <cap-functionbar-searchresult-buttons [listLoader]="auftragLoader"></cap-functionbar-searchresult-buttons>
  </cap-title-functionbar>
</cap-content-header>

@if (auftragResponse) {
  <cap-list-loader [listLoader]="auftragLoader" [showZeilenSelect]="false">
    <div class="cap-list-loader-title">
      <ng-content select="[name=title]"></ng-content>
    </div>
    <div class="cap-list-loader-content">
      <table class="cap-table-search">
        <thead>
          <ng-template [ngTemplateOutlet]="tableHeaders"></ng-template>
        </thead>
        <tbody>
          <ng-template [ngTemplateOutlet]="tableRows"></ng-template>
        </tbody>
      </table>
    </div>
  </cap-list-loader>
  <ng-template #tableHeaders>
    <tr>
      <th>
        <cap-column-header [columnName]="'AuftragsNr'" [sortModel]="tableSortModel.columns.get('auftragNr')"></cap-column-header>
      </th>
      <th>
        <cap-column-header [columnName]="'AuftragsTyp'" [sortModel]="tableSortModel.columns.get('auftragTyp')"></cap-column-header>
      </th>
      <th>
        <cap-column-header [columnName]="'ErstelltVon'" [sortModel]="tableSortModel.columns.get('ersteller')"></cap-column-header>
      </th>
      <th>
        <cap-column-header [columnName]="'Verarbeitungsstatus'" [sortModel]="tableSortModel.columns.get('verarbeitungsstatus')">
        </cap-column-header>
      </th>
      <th>
        <cap-column-header [columnName]="'Erstelldatum'" [sortModel]="tableSortModel.columns.get('erstelldatum')"></cap-column-header>
      </th>
      <th>
        <cap-column-header [columnName]="'Startdatum'" [sortModel]="tableSortModel.columns.get('startdatum')"></cap-column-header>
      </th>
      <th>
        <cap-column-header [columnName]="'Enddatum'" [sortModel]="tableSortModel.columns.get('enddatum')"></cap-column-header>
      </th>
      @if (permissionAuftragAdmin) {
        <th></th>
      }
    </tr>
  </ng-template>
  <ng-template #tableRows>
    @for (item of auftragLoader?.items; track item) {
      <tr>
        <td>
          <cap-link [queryParams]="{ id: item.id.id }" [target]="navTargets.NAV_STAPELVERARBEITUNG">
            @if (item.auftragJahr) {
              <span>{{ item.auftragJahr }}/</span>
            }
            {{ item.auftragNr }}
          </cap-link>
        </td>
        <td>
          <cap-link [queryParams]="{ id: item.id.id }" [target]="navTargets.NAV_STAPELVERARBEITUNG">
            {{ "datenexport." + item.datenexportAuftragTyp | translate }}
          </cap-link>
        </td>
        <td>
          <cap-link [queryParams]="{ id: item.id.id }" [target]="navTargets.NAV_STAPELVERARBEITUNG">
            {{ item.ersteller | kompaktBenutzer }}
          </cap-link>
        </td>
        <td>
          <cap-link [queryParams]="{ id: item.id.id }" [target]="navTargets.NAV_STAPELVERARBEITUNG">
            {{ item.exportResultWebTyp | translate }}
          </cap-link>
        </td>
        <td>
          <cap-link [queryParams]="{ id: item.id.id }" [target]="navTargets.NAV_STAPELVERARBEITUNG">
            {{ item.erstelldatum | datum }}
          </cap-link>
        </td>
        <td>
          <cap-link [queryParams]="{ id: item.id.id }" [target]="navTargets.NAV_STAPELVERARBEITUNG">
            {{ item.startdatum | datum }}
          </cap-link>
        </td>
        <td>
          <cap-link [queryParams]="{ id: item.id.id }" [target]="navTargets.NAV_STAPELVERARBEITUNG">
            {{ item.enddatum | datum }}
          </cap-link>
        </td>
        @if (permissionAuftragAdmin) {
          <td class="text-end">
            <button
              (click)="onReset(item.id.id)"
              [ngbTooltip]="'AuftragLoeschen' | translate"
              class="btn btn-danger btn-sm deleteButton"
              placement="left"
              type="button">
              <i class="fas fa-trash"></i>
            </button>
          </td>
        }
      </tr>
    }
  </ng-template>
} @else {
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-1 text-center">
        <cap-spinner-small></cap-spinner-small>
      </div>
    </div>
  </div>
}
